import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { Col, Grid, Row } from '../../ui/Grid';
import ProgressBar from '../../ui/ProgressBar';
import s from './DeepSEAInsilicoPage.css';
import InsilicoForm from './InsilicoForm';
import InsilicoBrowser from './InsilicoBrowser';

const DeepSEAInsilicoPage = ({ id }) => {
  const isFetching = useSelector(
    state => state.deepsea.in_silico_mutagenesis.isFetching,
  );

  const progress = (
    <ProgressBar
      label="Retrieving data for in silico mutagenesis heatmap..."
      style={{
        width: '80%',
        marginLeft: 'auto',
        marginRight: 'auto',
      }}
    />
  );

  return (
    <div className={s.root}>
      <Grid>
        <Row>
          <Col md={12}>
            <h2>
              In silico mutagenesis
              <br />
              <small>
                Discover informative regulatory sequence features within the
                provided sequences.
              </small>
            </h2>
            <hr />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className={s.container}>
              {isFetching ? progress : <InsilicoBrowser />}
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <h4 style={{ paddingBottom: '15px', paddingTop: '20px' }}>
              Choose a sequence and a feature below, then submit to retrieve the
              analysis:
            </h4>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <InsilicoForm jobId={id} />
          </Col>
        </Row>
      </Grid>
    </div>
  );
};

DeepSEAInsilicoPage.propTypes = {
  id: PropTypes.string.isRequired,
};

export default withStyles(s)(DeepSEAInsilicoPage);
